import { startCase, toLower, upperFirst } from 'lodash';

export const formatYupError = (
  error?: string,
  withFieldName?: boolean
): string | undefined => {
  if (error) {
    const errorParts = error.split(' ');
    const message = errorParts.slice(1).join(' ');

    if (withFieldName) {
      let fieldName = errorParts[0];

      if (fieldName.indexOf('.') > -1) {
        const fieldParts = fieldName.split('.');
        fieldName = fieldParts[fieldParts.length - 1];
      }

      return upperFirst(toLower(startCase(fieldName))) + ' ' + message;
    }

    return message;
  }
};
